import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { FormattedMessage, useIntl } from "react-intl";
import Icon from "@mui/material/Icon";
import clsx from "clsx";
import { useAlert } from "react-alert";
import Button from "@mui/material/Button";
import { useMutation } from "@apollo/client";
import { Typography, Grid, Box } from "@mui/material";
import TextAreaFull from "../common/FormControl/TextAreaFull";


import SimpleModalCompact from "../common/ModalCompact/SimpleModalCompact";
import { SEND_SUPPLIER_MESSAGE } from "../../graphql/mutations";

const useStyles = makeStyles(theme => ({
  btnSend: {
    padding: "5px 15px",
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
    },
  },
  btnIcon: {
    fontSize: 14,
    marginLeft: 8,
    verticalAlign: "middle",
  },
  label: {
    fontSize: 12,
    marginBottom: 0,
  },
  labelMsg: {
    fontSize: 12,
    marginBottom: 0,
    display: "inline-block",
    marginRight: 10,
  },
  msgAttach: {
    display: "inline-block",
    backgroundColor: theme.palette.background.contrastGray,
    padding: "3px 5px",
    borderRadius: 4,
    fontSize: 12,
    "& .MuiIcon-root": {
      width: "unset",
      height: "unset",
      overflow: "unset",
      fontSize: 12,
      marginRight: 5,
      backgroundColor: theme.palette.common.blue,
      padding: 2,
      borderRadius: 4,
      color: theme.palette.common.white,
    },
  },
}));

const ReplyModal = ({
  open,
  onClose,
  orderId,
  supplierOrderId,
}) => {
  const classes = useStyles();
  const alert = useAlert();
  const intl = useIntl();

  const [sendEmailTouser] = useMutation(SEND_SUPPLIER_MESSAGE);
  const [message, setMessage] = useState("");

  const handleSend = async () => {
    try {
      const res = await sendEmailTouser({
        variables: { supplierOrderId, message },
      });
      debugger;
      if (
        res?.data?.incomingOrders?.sendMessageToOrderer
      ) {
        alert.success(<FormattedMessage id="pickingList.replySent" />);
      } else {
        alert.error(<FormattedMessage id="common.genericErrorMessage" />);
      }
      onClose?.();
    } catch (err) {
      console.error("error >", err);
    }
  };


  return (
    <SimpleModalCompact fullScreen={false} open={open} onClose={onClose} title={<FormattedMessage id="btn.reply" />} >
            <Grid container spacing={2} className={classes.formControl}>
          <Grid item xs={12}>
            <Box>
              <Typography className={classes.labelMsg}>
                <FormattedMessage id="context.message" />
              </Typography>
              <Box className={classes.msgAttach}>
                <Icon className="fa fa-paperclip" />
                Order {orderId}
              </Box>
            </Box>
            <TextAreaFull
            placeholder={intl.formatMessage({
              id: "context.message",
            })}
            rows="8"
            rowsMax="8"
            value={message}
            onChange={e => setMessage(e.target.value)}
            sx={{minWidth: "500px"}}
            />
          </Grid>
        </Grid>
      <Button
        className={classes.btnSend}
        onClick={() => handleSend()}
        sx={{ marginTop:1}}
      >
        <FormattedMessage id="btn.send" />
        <Icon className={clsx(["fa fa-paper-plane", classes.btnIcon])} />
      </Button>
    </SimpleModalCompact>
  );
};

ReplyModal.defaultProps = {
  supplierOrderId: null,  
};

ReplyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  supplierOrderId: PropTypes.number,  
};

export default ReplyModal;
